document.addEventListener('DOMContentLoaded', () => {
  const flipAnimationWrap = document.querySelector('.flip-animation-wrap'),
        arrowsWrap = document.querySelector('.arrows-wrap'),
        flipContainer = document.querySelector('.flip-container'),
        feelContainer = document.querySelector('.feel-container'),
        nSymbol = document.querySelector('.n-symbol'),
        reversedLetters = document.querySelectorAll('span.reverse'),
        modelNames = document.querySelectorAll('span.model-name');

  // Function to set default styles for feelContainer and flipContainer
  function setDefaultStyles() {
    gsap.set(feelContainer, { top: '21.5%', left: '40.6%' });
    gsap.set(flipContainer, { top: '17.1%', left: '0.4%' });
  }

  // Set default styles initially
  setDefaultStyles();

  const elementsToReset = [arrowsWrap, nSymbol, flipContainer, feelContainer];
  const initialStyles = new Map();
  elementsToReset.forEach(el => {
    initialStyles.set(el, el.style.cssText); // Store original inline styles
  });

  // GSAP matchMedia to handle animations based on media queries
  const matchMedia = gsap.matchMedia();

  matchMedia.add("(min-width: 750px)", () => {
    const tl = gsap.timeline({ paused: true });

    tl.to(arrowsWrap, {
      rotation: -360,
      duration: 1,
      ease: 'sine.inOut',
    })
    .fromTo(nSymbol, 
      { scale: 1, rotation: 0 }, 
      { 
        rotation: 10, 
        duration: 0.5, 
        ease: 'sine.inOut', 
        yoyo: true, 
        repeat: 1 
      },'<') 
    .fromTo(nSymbol, 
      { scale: 1, rotation: 0 }, 
      { scale: 1.2,
        rotation: 360, 
        duration: 1, 
        ease: 'sine.inOut', 
      },'<') 
    .to(flipContainer,{
      rotateY: -360,
      top: '22.6%',
      left: '40.6%',
      duration: 1,
      ease: 'sine.inOut',
    },'<')
    .to(feelContainer,{
      top: '16.6%',
      left: '0%',
      duration: 1,
      ease: 'sine.inOut',
    },'<')
    .to(reversedLetters,{
      scaleX: -1, 
      duration: .5,
      stagger: 0.5,
      ease: 'sine.inOut',
    },'<')
    

    flipAnimationWrap.addEventListener('mouseenter', () => {
      tl.play();
    });

    flipAnimationWrap.addEventListener('mouseleave', () => {
      tl.reverse();
    });

    window.addEventListener('resize', () => {
      tl.totalTime(0); // Reset the timeline
      elementsToReset.forEach(el => { // Restore elements to their original inline styles
        el.style.cssText = initialStyles.get(el); // Reset styles
        gsap.set(el, { clearProps: "all" }); // Reset all GSAP transformations
      });
      // Reapply default styles
      setDefaultStyles();
    });

    // Return a cleanup function to remove event listeners when the media query no longer matches
    return () => {
      flipAnimationWrap.removeEventListener('mouseenter', () => tl.play());
      flipAnimationWrap.removeEventListener('mouseleave', () => tl.reverse());
      window.removeEventListener('resize', () => {
        tl.totalTime(0);
        elementsToReset.forEach(el => {
          el.style.cssText = initialStyles.get(el);
          gsap.set(el, { clearProps: "all" });
        });
        setDefaultStyles();
      });
    };
  });
});